import { createAction } from '@reduxjs/toolkit';
import { PosOrganizationModel } from "app/reducers/pos.reducer";

export const loadInfo = createAction<void>('[POS] Load');
export const setInfo = createAction<PosOrganizationModel[]>('[POS] Set');

export const posRequestError = createAction<string>('[POS] Error')